import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState, useMemo, useContext, useEffect } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
// Internal dependencies
import { ButtonSG } from '../components';
import { appStyles } from '../App.styles';
import { Billing } from './Billing';
import { Subscription } from './Subscription';
import { settingsStyles } from './settingsStyles';
import { MyAccount } from './MyAccount';
import { TabNamesTypes } from './constants';
import { CLIENT_ENDPOINTS } from '../constants';
import { UserContext } from '../auth';
;
/**
 * Settings
 * @param {SettingsProps} props
 * @returns {JSX.Element}
 */
export const Settings = function (props) {
    const navigate = useNavigate();
    const user = useContext(UserContext);
    // Use query
    function useQuery() {
        const { search } = useLocation();
        return useMemo(() => new URLSearchParams(search), [search]);
    }
    // Get query
    const query = useQuery();
    // Use translation
    const { t } = useTranslation();
    // Tab name
    const [tabName, setTabName] = useState(query.get('tab') ? query.get('tab') : TabNamesTypes.MyAccount);
    useEffect(() => { setTabName(query.get('tab')); }, [query.get('tab')]);
    return (_jsxs(Box, Object.assign({ sx: {
            backgroundColor: '#ffffff',
            padding: {
                sm: '1.5rem 1.5rem 0',
                xs: '0.5rem 0.5rem 0',
            },
            borderRadius: '1rem',
            height: 'calc(100%)',
            boxSizing: 'border-box',
            overflow: 'hidden',
            boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
        } }, { children: [_jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text28), { padding: '0 0 1.5rem', color: '#000000' }) }, { children: t('Settings') })), _jsxs(Grid, Object.assign({ container: true, sx: {
                    padding: '0',
                    maxWidth: '360px',
                    width: '100%',
                } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(ButtonSG, Object.assign({ variant: "text", sx: Object.assign(Object.assign(Object.assign({}, appStyles.text14), settingsStyles.tabButton), { borderBottom: tabName === TabNamesTypes.MyAccount ? '2px solid #006B54' : '0' }), onClick: () => {
                                if (!user) {
                                    navigate(CLIENT_ENDPOINTS.SIGN_IN);
                                    return;
                                }
                                setTabName(TabNamesTypes.MyAccount);
                            } }, { children: t('My Account') })) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(ButtonSG, Object.assign({ variant: "text", sx: Object.assign(Object.assign(Object.assign({}, appStyles.text14), settingsStyles.tabButton), { borderBottom: tabName === TabNamesTypes.Billing ? '2px solid #006B54' : '0' }), onClick: () => {
                                if (!user) {
                                    navigate(CLIENT_ENDPOINTS.SIGN_IN);
                                    return;
                                }
                                setTabName(TabNamesTypes.Billing);
                            } }, { children: t('Billing') })) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(ButtonSG, Object.assign({ variant: "text", sx: Object.assign(Object.assign(Object.assign({}, appStyles.text14), settingsStyles.tabButton), { borderBottom: tabName === TabNamesTypes.Subscription ? '2px solid #006B54' : '0' }), onClick: () => { setTabName(TabNamesTypes.Subscription); } }, { children: t('Subscription') })) }))] })), _jsxs(Box, Object.assign({ sx: {
                    height: 'calc(100% - 60px - 50px)',
                    padding: '1.5rem 0 0',
                    overflow: 'auto',
                } }, { children: [_jsx(Box, Object.assign({ sx: {
                            display: tabName === TabNamesTypes.MyAccount ? 'block' : 'none',
                            height: '100%',
                        } }, { children: _jsx(MyAccount, {}) })), _jsx(Box, Object.assign({ sx: {
                            display: tabName === TabNamesTypes.Billing ? 'block' : 'none',
                            height: '100%',
                        } }, { children: _jsx(Billing, {}) })), _jsx(Box, Object.assign({ sx: {
                            display: tabName === TabNamesTypes.Subscription ? 'block' : 'none',
                            height: '100%',
                        } }, { children: _jsx(Subscription, {}) }))] }))] })));
};
